class GiftWrapProduct extends HTMLElement {
  static lastChecked = null;

  constructor() {
    super();

    this.checkbox = this.querySelector('[name="gift_wrap"]');
    this.form = this.closest('form');

    this.checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
  }

  handleCheckboxChange() {
    if (this.checkbox.checked) {

      // Prevent duplicate hidden input
      if (!this.form.querySelector('.pg_prop')) {
        this.form.insertAdjacentHTML(
          'beforeend',
          `<input class="pg_prop" type="hidden" name="properties[Want it gift wrapped?]" value="Yes please" />`
        );
      }

      // Add button only once
      if (!this.querySelector('.giftwrapatc')) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'giftwrapatc';
        btn.textContent = '';
        btn.addEventListener('click', this.addToCart.bind(this));
        this.appendChild(btn);
      }

    } else {
      const prop = this.form.querySelector('.pg_prop');
      const atc = this.querySelector('.giftwrapatc');
      if (prop) prop.remove();
      if (atc) atc.remove();
    }
  }

  addToCart() {
    const formData = new URLSearchParams();
    formData.append('id', this.checkbox.value);
    formData.append('quantity', 1);

    fetch(`${window.Theme.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json',
      },
      body: formData.toString()
    })
      .then(res => res.json())
      .then(data => {
        console.log('Added gift wrap:', data);
      })
      .catch(err => console.error(err));
  }
}

customElements.define('gift-wrap', GiftWrapProduct);
